module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// G:/proyectos/website - IntergraMAI/webMai/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 0